import CryptoJS from 'crypto-js';
import { btoa, atob, showAlert } from '../../lib/helpers';
import { dataIntervalExport } from '../params';
import { postApi } from '../../lib/fetcher';

const aggregator = {
  namespaced: true,

  state() {
    return {
      allAggregators: [],
      totalAggregators: 0,
      allMerchants: [],
      totalMerchants: 0,
      loading: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      merchant: null,
      aggregator: null,
      aggregatorDocument: [],
      countData: 0,
      countSuccess: 0,
      countFailed: 0,
      uploadProgress: 0,
      onUpload: false,
      insertProgress: 0,
      onInsert: false,
      insertName: '',
      importId: null,
      downloadFailedURL: '',
      countDone: 0,
      countSame: 0,
      intervalImport: null,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,
      totalPage: 0,
    };
  },

  mutations: {
    setAggregators(state, { payload }) {
      state.allAggregators = payload.data.list;
    },

    setMerchants(state, { payload }) {
      state.allMerchants = payload.data.list;
    },

    clearMerchants(state) {
      state.allMerchants = [];
      state.totalMerchants = 0;
    },

    setTotalMerchants(state, { payload }) {
      state.totalMerchants = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearAggregators(state) {
      state.allAggregators = [];
      state.totalAggregators = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalAggregators(state, { payload }) {
      state.totalAggregators = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setDetailAggregator(state, { payload }) {
      state.aggregator = payload;
    },

    setAggregatorDocument(state, document) {
      state.aggregatorDocument.push(document);
    },

    setAggregatorVariable(state, { variable, payload }) {
      state.aggregator[variable] = payload;
    },

    setUploadProgress(state, uploadProgress) {
      state.uploadProgress = uploadProgress;
    },
    setOnUpload(state, onUpload) {
      state.onUpload = onUpload;
    },
    setInsertProgress(state, insertProgress) {
      state.insertProgress = insertProgress;
    },
    setInsertName(state, insertName) {
      state.insertName = insertName;
    },
    setOnInsert(state, onInsert) {
      state.onInsert = onInsert;
    },
    setIntervalImport(state, payload) {
      state.intervalImport = payload;
    },
    setImportData(state, payload) {
      state.importId = payload.import_id;
      state.countData = payload.count_data;
    },
    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },
    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },
    setDownloadFailedURL(state, payload) {
      state.downloadFailedURL = payload;
    },
    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },
    clearLastResult(state) {
      state.countData = 0;
      state.countSuccess = 0;
      state.countFailed = 0;
      state.countDone = 0;
      state.countSame = 0;
      state.uploadProgress = 0;
      state.onUpload = false;
      state.insertProgress = 0;
      state.onInsert = false;
      state.insertName = '';
      state.intervalImport = null;
      state.importId = null;
      state.downloadFailedURL = '';
    },
  },

  actions: {
    async fetchAggregators(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      ctx.commit('clearAggregators');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/client/aggregator/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setTotalAggregators', {
          payload: responseData,
        });
        ctx.commit('setAggregators', {
          payload: responseData,
        });
      }
    },

    async fetchMerchants(
      ctx,
      {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search,
        aggregatorId,
        merchantId,
        action,
      }
    ) {
      ctx.commit('clearMerchants');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const controller = (ctrl) => {
        switch (ctrl) {
          case 'merchant':
            return 'submerchant/submerchant/index';
          case 'outlet':
            return 'outlet/outlet/index';
          default:
            return 'merchantsub/submerchant/index';
        }
      };
      const aggregatorIdVal = aggregatorId == null ? '' : aggregatorId;
      const merchantIdVal = merchantId == null ? '' : merchantId;

      const version = (act) => {
        switch (act) {
          case 'merchant':
            return btoa(
              CryptoJS.SHA256(
                aggregatorIdVal.toString() +
                  sort_by.toString() +
                  itemsPerPage.toString() +
                  page.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            );
          case 'outlet':
            return btoa(
              CryptoJS.SHA256(
                merchantIdVal.toString() +
                  sort_by.toString() +
                  itemsPerPage.toString() +
                  page.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            );
          default:
            return btoa(
              CryptoJS.SHA256(
                itemsPerPage.toString() +
                  page.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            );
        }
      };

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        aggregator_id: aggregatorIdVal.toString(),
        merchant_id: merchantIdVal.toString(),
        version: version(action),
      });

      const urlApi = `/index.php?r=api/v1/${controller(action)}`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setTotalMerchants', {
          payload: responseData,
        });
        ctx.commit('setMerchants', {
          payload: responseData,
        });
      }
    },

    async viewAggregator(ctx, { date, id }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/client/aggregator/view`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setDetailAggregator', {
          payload: responseData.data,
        });
      }
    },
    async exportList(
      ctx,
      {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search,
        view,
        IDAggregator,
        IDMerchant,
      }
    ) {
      if (ctx.rootState.isExport) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export in progress !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        return;
      }
      ctx.commit('setLoading', true);
      ctx.commit('setIsExport', true, { root: true });
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'countSameExport',
      });
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        const q = sortBy[0] == 'name' ? 'merchant_name' : sortBy[0];
        sort_by = `${q} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }
      const controller = (ctrl) => {
        switch (ctrl) {
          case 'aggregator':
            return 'export-aggregator-list';
          case 'sub-merchant':
            return 'export-sub-merchant-list';
          case 'sub-merchant-outlet':
            return 'export-outlet-list';
          default:
            return 'export-aggregator-list';
        }
      };

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        aggregator_id: IDAggregator.toString(),
        merchant_id: IDMerchant.toString(),
        version: btoa(
          CryptoJS.SHA256(
            IDAggregator.toString() +
              itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
        ctx.commit('setIsExport', false, { root: true });
      };

      const urlApi = `/index.php?r=api/v1/export/${controller(view)}/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        if (responseData.data.message != null) {
          showAlert(ctx, responseData.data.message, 'mdi-alert', 'red');
          ctx.commit('setIsExport', false, { root: true });
          return;
        }
        ctx.commit('setExportData', responseData.data);
        const interval = setInterval(() => {
          ctx.dispatch(
            'exportStatus',
            {
              date,
              exportId: ctx.state.exportId,
              countDataExport: ctx.state.countDataExport,
              controller: controller(view),
            },
            { root: true }
          );
        }, dataIntervalExport);
        ctx.commit('setIntervalExport', interval, { root: true });
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: true,
            absoluteBarText: 'Start to export data..',
          },
          { root: true }
        );
      } else {
        failed();
      }
    },
  },
};

export default aggregator;
